import { MeasureCard } from '../../components/viz/MeasureCard';
import { DashboardLayout } from './DashboardLayout';

export function CertificatesDashboard() {
  return (
    <DashboardLayout
      title="Certificates"
      intro="Certificate issuance via the aXcelerate portfolio. Scans (type 48739) are excluded — these are training certificates and statements of attainment."
    >
      <MeasureCard
        title="Issued — last 90 days"
        description="Excludes Scans (type 48739)."
        spec={{ measure: 'certificates.issued_last_90d' }}
        viz="kpi"
      />
      <MeasureCard
        title="Pending issuance"
        description="Completed enrolments with no portfolio row recording a date_issued."
        spec={{ measure: 'certificates.pending_completions' }}
        viz="kpi"
      />
      <MeasureCard
        title="By folder — last 12 months"
        description="Certificates by qualification family (FOLDER field)."
        spec={{ measure: 'certificates.by_folder' }}
        viz="bar"
      />
    </DashboardLayout>
  );
}
